import { render, staticRenderFns } from "./Agreement-2-1.vue?vue&type=template&id=b747a04a&"
import script from "./Agreement-2-1.vue?vue&type=script&lang=js&"
export * from "./Agreement-2-1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports